import StarsWithOpinions from '@/components/sections/StarsWithOpinions'

import { Wrapper } from './StarsWithOpinions.styled'

function StarsWithOpinionsComponent() {
  return (
    <Wrapper>
      <StarsWithOpinions />
    </Wrapper>
  )
}

export default StarsWithOpinionsComponent
